module.exports = __webpack_public_path__ + "img/绍兴思德龙.36bcb333.jpg";